import { ProductPayload, Products, ProductsAction } from "../interfaces/global-interfaces";

export default function productAction(products: ProductPayload[]) {
    return {
        type: ProductsAction.Update,
        payload: products
    } as Products
}